import { firebaseCollectionNames } from '../../firebase/firebaseConstants'
import { usePersistentCollection } from '../../firebase/hooks/usePersistentCollection'
import { TextContentType } from './types'

export function useTextContent() {
  const { collection } = usePersistentCollection<TextContentType>(firebaseCollectionNames.textContent)

  return collection?.value || []
}
